import {
  VuexModule,
  Module,
  Action,
  Mutation,
  getModule
} from 'vuex-module-decorators'
import { login } from '@/api/user'
import {
  getToken,
  setToken,
  removeToken,
  removeName,
  removeLogo,
  setType,
  setAntToken,
  getAntToken,
  removeAntToken
} from '@/utils/cookies'
import { resetRouter } from '@/router'
import { TagsViewModule } from './tags-view'
import { PermissionModule } from './permission'
import store from '@/store'
import { AppModule } from './app'

export interface IUserState {
  token: string
  email: string
  avatar: string
  baseUrl: any
  sysType: string
  antToken: string
}

@Module({ dynamic: true, store, name: 'user' })
class User extends VuexModule implements IUserState {
  public token = getToken() || ''
  public antToken = getAntToken() || ''
  public email = '' // 邮箱
  public avatar =
    'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif'
  public baseUrl: any
  public sysType: any

  @Mutation
  private SET_TOKEN (token: string) {
    this.token = token
  }

  @Mutation
  private SET_ANT_TOKEN (token: string) {
    this.antToken = token
  }

  @Mutation
  private SET_EMAIL (email: string) {
    this.email = email
  }

  @Mutation
  private SET_SYSTYPE (sysType: string) {
    this.sysType = sysType
    setType(sysType)
  }

  @Mutation
  private SET_BASEURL (baseUrl: any) {
    this.baseUrl = baseUrl
  }

  @Action
  public SetSysType (sysType: any) {
    this.SET_SYSTYPE(sysType)
  }

  @Action
  public SetBaseUrl (baseUrl: any) {
    this.SET_BASEURL(baseUrl)
  }

  @Action
  public SetToken (token: string) {
    this.SET_TOKEN(token)
    setToken(token)
  }

  @Action
  public SetAntToken (token: string) {
    this.SET_ANT_TOKEN(token)
    setAntToken(token)
  }

  @Action
  public async Login (userInfo: {
    username: string
    password: string
    code: string
  }) {
    let { username, password, code } = userInfo
    username = username.trim()
    try {
      await login({ username, password, code }).then((res: any) => {
        if (res.token) {
          setToken(res.token)
          setAntToken('')
          this.SET_TOKEN(res.token)
          this.SET_ANT_TOKEN('')
        }
      })
    } catch (err) {
      let e: any = err
      return new Error(e)
    }
  }

  @Action
  public ResetToken () {
    removeToken()
    removeAntToken()
    this.SET_TOKEN('')
    this.SET_ANT_TOKEN('')
  }

  @Action
  public async LogOut () {
    removeToken()
    resetRouter()
    removeName()
    removeLogo()
    removeAntToken()
    AppModule.ResetEnterprise()
    PermissionModule.resetAllPermission()
    // 重置已访问的视图和缓存的视图
    TagsViewModule.delAllViews()
    this.SET_TOKEN('')
    this.SET_SYSTYPE('')
  }
}

export const UserModule = getModule(User)
